import { render, staticRenderFns } from "./productlisting.vue?vue&type=template&id=3ddb5796&scoped=true&"
import script from "./productlisting.vue?vue&type=script&lang=js&"
export * from "./productlisting.vue?vue&type=script&lang=js&"
import style0 from "./productlisting.vue?vue&type=style&index=0&id=3ddb5796&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddb5796",
  null
  
)

export default component.exports